import React from 'react';
import {
  Card as MuiCard,
  CardProps as MuiCardProps,
  CardContent,
  Typography,
  Box,
} from '@mui/material';
import styled from 'styled-components';

interface CardProps extends MuiCardProps {
  title?: string;
  subtitle?: string;
  loading?: boolean;
  error?: string;
  children: React.ReactNode;
}

const StyledCard = styled(MuiCard)<{ loading?: boolean }>`
  position: relative;
  border-radius: 16px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
  }

  ${({ loading }) =>
    loading &&
    `
    pointer-events: none;
    opacity: 0.7;
  `}
`;

const CardHeader = styled(Box)`
  padding: 1.5rem 1.5rem 0;
`;

const StyledCardContent = styled(CardContent)`
  padding: 1.5rem !important;
`;

const ErrorMessage = styled(Typography)`
  color: ${({ theme }) => theme.palette.error.main};
  margin-top: 0.5rem;
`;

const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  loading = false,
  error,
  children,
  ...props
}) => {
  return (
    <StyledCard loading={loading} {...props}>
      {(title || subtitle) && (
        <CardHeader>
          {title && (
            <Typography variant="h6" gutterBottom>
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography variant="body2" color="textSecondary">
              {subtitle}
            </Typography>
          )}
        </CardHeader>
      )}
      <StyledCardContent>
        {children}
        {error && <ErrorMessage variant="body2">{error}</ErrorMessage>}
      </StyledCardContent>
    </StyledCard>
  );
};

export default Card; 